module.exports = __webpack_public_path__ + "img/computerMechanism.908a4303.jpg";